const _ = require('lodash');
const mapping = require('arbitrip-common/theme/mapping');
const { COMPANY_NAME } = require('arbitrip-common/theme/constants');
const { loadZendeskChat } = require("./utils");

function isElalProfile(profile) {
    const companyId = _.get(profile, 'company.id');
    return mapping[String(companyId)] === COMPANY_NAME.ELAL || mapping.getCompanyNameFromHostname() === COMPANY_NAME.ELAL;
}

function boot(profile, options = {}) {
    const enabled = _.get(profile, 'chat_enabled', false);
    if (!enabled) return;

    const isLoggedIn = _.get(profile, 'isLoggedIn', false);
    // El Al opens the chat for anonymous users too; every other brand keeps it logged-in only.
    const allowAnonymous = isElalProfile(profile);
    if (isLoggedIn || allowAnonymous) {
        loadZendeskChat(profile, options)
    }
}

module.exports = {
    boot,
};
